import useEligibleUSPayment from './useEligibleUSPayment';
import useFeatureFlag from './useFeatureFlag';

/**
 * Returns sikaPayments isEnabled flag
 *
 * Country Eligibility favors billing address country but falls back to
 * app country so we can utiize this outside of checkout e.g. to display
 * HSA/FSA messaging on the PDP
 */
export const useSikaPayments = (): { isEnabled: boolean } => {
  const isEligibleUSPayment = useEligibleUSPayment();
  const featureFlagEnabled = useFeatureFlag('sika-payments');

  return {
    isEnabled: isEligibleUSPayment && !!featureFlagEnabled,
  };
};
